export const SNS = {
  ROUTE_NAME: {
    naver: '네이버',
    kakao: '카카오',
    apple: '애플',
  },
  COOKIE_NAME: {
    naver: 'naverUid',
    kakao: 'kakaoUid',
    apple: 'appleUid',
  }
};

// CI 체크 제외 회원 ID (QA자동화 회원가입용)
export const NO_CICHECK_USERID = {
  dev: ['test01','test03','test05','test07','test08','test09','01044717913','01075105149', '01065645149','01029907235','01074425149','sunook0718'],
  production: ['test01','test03','test05','test07','test08','test09','01077661446', 'gktjdals13','01029907235','01074425149','sunook0718',],
};

// 로그인 이후 연결되는 URL에서 제외
export const EXCLUDE_RETURN_URL = [
  '/member/register', 
  '/member/joinGate', 
  '/member/find',
];